import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=345e5400&scoped=true&lang=pug&"
import script from "./CreateGroup.vue?vue&type=script&lang=js&"
export * from "./CreateGroup.vue?vue&type=script&lang=js&"
import style0 from "./CreateGroup.vue?vue&type=style&index=0&id=345e5400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345e5400",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/Kou/projects/vue-projects/joseph/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VFlex,VTextField})
